export enum CategoryType {
  MAIN = 'Main',
  APARTMENT = 'Apartment',
}
export enum ConnectStatus{
  ONLINE='Online',
  OFFLINE='Offline'
}

